import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "layer deletAlt msgDivision" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "layerTitle" }, "문자 메시지 분활 발송", -1)
const _hoisted_3 = {
  class: "layerMain",
  style: {"max-height":"400px","overflow-y":"auto"}
}
const _hoisted_4 = {
  key: 0,
  class: "layerMainTitle"
}
const _hoisted_5 = { class: "overflow timeSelectArea" }
const _hoisted_6 = { class: "left mgR15" }
const _hoisted_7 = ["onUpdate:modelValue", "onChange"]
const _hoisted_8 = {
  key: 1,
  class: "retimeBlock"
}
const _hoisted_9 = { class: "right" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "grayBox" }, " 클릭하여 회차별 발송 시작 일자를 수정하실 수 있습니다 ", -1)
const _hoisted_12 = { class: "layerBtnArea" }
const _hoisted_13 = { class: "layer deletAlt" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "layerTitle" }, "알림", -1)
const _hoisted_15 = { class: "layerMain" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "layerMainText" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold red" }, " 폰발송 가능 건수를 초과 "),
  /*#__PURE__*/_createTextVNode("하였습니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "초과한 건"),
  /*#__PURE__*/_createTextVNode("에 대해서 웹발송을 하거나 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 다른 날짜에 폰발송을 예약하실 수 있습니다. ")
], -1)
const _hoisted_17 = { class: "mgB10" }
const _hoisted_18 = { class: "mgB10" }
const _hoisted_19 = { class: "layerBtnArea" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.tmpl, (r) => {
          return (_openBlock(), _createElementBlock("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.dist_list.filter(x => x.SEND_NO == r.SEND_NO), (r1) => {
              return (_openBlock(), _createElementBlock("span", null, [
                (r1.ROW_NO==1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(r.SEND_NO) + "회차 : " + _toDisplayString(r1.SEND_DA2) + "(" + _toDisplayString(r1.DATENAME) + ") " + _toDisplayString(r.TM), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (r1.ROW_NO==1)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "date",
                          "onUpdate:modelValue": ($event: any) => ((r1.SEND_DA2) = $event),
                          onChange: ($event: any) => ($options.change_date(r1))
                        }, null, 40, _hoisted_7)), [
                          [_vModelText, r1.SEND_DA2]
                        ])
                      : _createCommentVNode("", true),
                    _createTextVNode(" (" + _toDisplayString(r1.DATENAME) + ") ", 1),
                    (r1.ROW_NO > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(r1.SEND_DA2), 1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(r.CUST_SEND_TM), 1)
                  ]),
                  _createTextVNode(" " + _toDisplayString(r1.IS_SMT == 1 ? "폰발송" : "코인발송") + " ", 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("input", {
                      type: "text",
                      value: r1.SEND_CNT,
                      readonly: "",
                      style: {"width":"50px"}
                    }, null, 8, _hoisted_10),
                    _createTextVNode("건 ")
                  ]),
                  _createTextVNode("    ")
                ])
              ]))
            }), 256))
          ]))
        }), 256)),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.tmpl_info_save()))
        }, "확인"),
        _createTextVNode("  "),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.is_view_dist=false))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.is_view_dist]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "mgR05",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.api.send_type) = $event)),
              value: 2
            }, null, 512), [
              [_vModelRadio, $data.api.send_type]
            ]),
            _createTextVNode("다른 날짜에 폰발송 예약 (무료)")
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "mgR05",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.api.send_type) = $event)),
              value: 3
            }, null, 512), [
              [_vModelRadio, $data.api.send_type]
            ]),
            _createTextVNode("당일 폰발송가능건 외 잔여건 코인발송(부분유료)")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.dist_view()))
        }, "확인"),
        _createTextVNode("  "),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.is_view_alert=false))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.is_view_alert]
    ])
  ], 64))
}